export default __webpack_public_path__ + "static/media/wi-day-haze.acbeaedc.svg";